import { Reisperiode } from "@/entities/tvv";
import { z } from "zod";

export const bestellingFormSchema = z.object({
    reisperiode: z.enum(Reisperiode),
    busFrequentie: z.coerce.number<number>().min(1, "Minimaal 1"),
    aantalBussen: z.coerce.number<number>().min(1, "Minimaal 1"),
    bussenBeginStation: z.coerce.number<number>().min(0),
    bussenEindStation: z.coerce.number<number>().min(0),
    percentageBeginStation: z.coerce.number<number>().min(0).max(100),
    ovLijnNummer: z.string().optional(),
    isAangepast: z.boolean(),
});

export const routeBestellingSchema = z.object({
    routeId: z.number(),
    voorwaardeGeaccepteerd: z.boolean(),
    bestelling: bestellingFormSchema,
});

export const bestellingenSchema = z.object({
    bestellingen: z.array(routeBestellingSchema),
});

export type BestellingFormData = z.infer<typeof bestellingFormSchema>;
export type RouteBestellingData = z.infer<typeof routeBestellingSchema>;
export type BestellingenFormData = z.infer<typeof bestellingenSchema>;
